var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('joinHead',{attrs:{"title":"观看党建政治学习视频"}}),_c('videoList',{staticClass:"video-box"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }